import { set } from 'lodash';
import type { TApiError } from './types';

type BackendError<T> = TApiError<T> & { data?: unknown };

export async function parseError<T>(error: unknown) {
	try {
		const response = (error as { response?: Response }).response;
		if (response) {
			const clonedError = response.clone();
			if (!clonedError.bodyUsed) {
				const err = (await clonedError.json()) as BackendError<T>;
				const parsedError = {
					message: err?.message,
					errors: {},
					data: err?.data,
				};

				Object.entries(err?.errors || {}).forEach(([key, value]) => {
					set(parsedError.errors as Record<string, unknown>, key, value);
				});

				return parsedError;
			}
		}
	} catch {
		return;
	}
}
